@if (isMarkerClustererActive) {
    <div>
        @if ((markerClustererIsLoaded$ | async) === true) {
            <map-marker-clusterer
                #markerClusterer
                [styles]="markerClustererStyles"
                [zoomOnClick]="true"
                [averageCenter]="true">
                @for (marker of markers; track trackByMarker($index, marker)) {
                    <map-marker
                        [position]="{ lat: marker.coordinates.latitude, lng: marker.coordinates.longitude }"
                        [options]="{
                            icon: {
                                url: marker.icon.url,
                                scaledSize: marker.icon.size | googleSize,
                            },
                        }"
                        (mapClick)="mapClicked(marker)"
                        (mapMouseover)="changeSvgOnHover(marker, true)"
                        (mapMouseout)="changeSvgOnHover(marker, false)">
                    </map-marker>
                }
            </map-marker-clusterer>
        }
    </div>
} @else {
    @for (marker of markers; track trackByMarker($index, marker)) {
        <map-marker
            [position]="{ lat: marker.coordinates.latitude, lng: marker.coordinates.longitude }"
            [options]="{
                icon: {
                    url: marker.icon.url,
                    scaledSize: marker.icon.size | googleSize,
                },
            }"
            (mapClick)="clickedMarkerCoordinates.emit(marker.coordinates)"
            (mapMouseover)="changeSvgOnHover(marker, true)"
            (mapMouseout)="changeSvgOnHover(marker, false)">
        </map-marker>
    }
}
